import { PlusCircleIcon } from '@heroicons/react/24/solid';
import React, { useState } from 'react';
import { twMerge } from 'tailwind-merge';

interface AdditionalStepCardProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  tag?: string;
  isShowing?: boolean;
  containerClassNames?: string;
  action?: () => void;
  dataTestId?: string;
}

const AdditionalStepCard = ({
  title,
  description,
  icon,
  tag,
  isShowing = true,
  containerClassNames,
  action,
  dataTestId,
}: AdditionalStepCardProps) => {
  const [isHovering, setIsHovering] = useState(false);

  const cardContainer = twMerge(
    'flex',
    'rounded-xl',
    'bg-white',
    'p-6',
    'gap-4',
    'items-center',
    'border',
    'border-kira-slate-200',
    'hover:border-kira-blue-800',
    'transition-colors',
    'duration-200',
    'ease-in-out',
    'cursor-pointer',
    `${containerClassNames || ''}`
  );

  const iconClasses = twMerge('w-8', 'h-8', 'text-kira-blue-800');

  const tagClasses = twMerge(
    'prose-body-sm-med',
    'bg-kira-yellow-900',
    'border',
    'border-kira-yellow-900',
    'rounded-full',
    'px-3',
    'py-0.5'
  );

  const handleOnClick = () => {
    if (!action) return;
    action();
  };

  return isShowing ? (
    <button
      type="button"
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
      className={cardContainer}
      onClick={handleOnClick}
      data-testid={dataTestId}
    >
      <div className="flex items-center">
        <div className={iconClasses}>
          {!isHovering ? icon : <PlusCircleIcon />}
        </div>
      </div>
      <div className="flex flex-col gap-1">
        <div className="prose-title-h5 flex items-center gap-2">
          {title}
          {tag ? <span className={tagClasses}>{tag}</span> : null}
        </div>
        <div className="prose-body-sm-reg text-left text-kira-slate-700">
          {description}
        </div>
      </div>
    </button>
  ) : null;
};

export default AdditionalStepCard;
